import { render, staticRenderFns } from "./ShippingPackage.vue?vue&type=template&id=041fa36a&scoped=true"
import script from "./ShippingPackage.vue?vue&type=script&lang=js"
export * from "./ShippingPackage.vue?vue&type=script&lang=js"
import style0 from "./ShippingPackage.vue?vue&type=style&index=0&id=041fa36a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041fa36a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VIcon,VRow,VTooltip})
